let id = 100;

/**
 * Generate a string unique across this session.
 */
export const getID = () => {
	id++;
	return id.toString();
};
